import React from 'react'
import { observer } from 'mobx-react'
import classNames from 'classnames'

import { PurchaseTerms } from 'shop/components/payment/new/purchaseTerms'
import { EloInfoIcon } from '@elo-ui/components/icons/regular'
import { EloTooltip } from '@elo-ui/components/elo-tooltip'

import I18n from '@elo-kit/components/i18n/i18n'

import { useShopStores } from 'shop/hooks/use-store'
import { useExpressCheckout } from 'shop/hooks/use-express-checkout'

import { ExpressCheckoutWrapper } from '../ExpressCheckoutWrapper'

interface Props {
  isInsidePlan?: boolean
}

export const OneClickPayment: React.FC<Props> = observer(({ isInsidePlan }) => {
  const { sellerStore, paymentStore, cancellationTermsStore, themeStore } = useShopStores()
  const { availableExpressCheckoutComponents, hasAvailableExpressCheckout } = useExpressCheckout()

  const expressCheckoutClasses = classNames('express-checkout', {
    'express-checkout__inside-plan': isInsidePlan,
  })

  const expressCheckoutTitleClasses = classNames('express-checkout__title', {
    'express-checkout__title--inside-plan': isInsidePlan,
  })

  // If no express checkout methods are configured, hide the component
  if (!hasAvailableExpressCheckout) {
    return null
  }

  return (
    <>
      <div className={expressCheckoutClasses}>
        <div className={expressCheckoutTitleClasses}>
          {isInsidePlan
            ? I18n.t('react.shop.complete_purchase_with_one_click')
            : I18n.t('react.shop.continue_with_express_checkout')}{' '}
          <EloTooltip placement='right' content={I18n.t('react.shop.express_checkout.tooltip.message')}>
            <EloInfoIcon size={16} />
          </EloTooltip>
        </div>
        <ExpressCheckoutWrapper>
          <div className='express-checkout__express-buttons'>{availableExpressCheckoutComponents}</div>
        </ExpressCheckoutWrapper>

        <div className='purchase express-checkout__purchase'>
          <PurchaseTerms
            isFree={false}
            link={paymentStore.product?.cancelLink}
            htmlTerms={cancellationTermsStore.item}
            checked={paymentStore.store?.terms}
            onCheckboxChange={(terms) => paymentStore.submitTerms(terms)}
            productType={paymentStore.product?.form}
            invoiceToken={paymentStore.invoice?.token}
            areHiddenCancellationTerms={
              paymentStore.payerFromType === 'business' && paymentStore.product?.hideB2bCancellationTerm
            }
            sellerUsername={sellerStore.item.username}
            isPowerSeller={sellerStore.item.powerSeller}
            usePowerSellerDocument={sellerStore.item.documentConfiguration?.termsOfBusiness}
            paymentPageColor={themeStore.ppTemplate?.theme?.paymentPageColor}
            showBusinessStatement={paymentStore.showBusinessStatement}
          />
        </div>
      </div>
      {!isInsidePlan && (
        <div className='express-checkout-separator'>
          <div />
          {I18n.t('react.shared.or')}
          <div />
        </div>
      )}
    </>
  )
})
